export default "__VITE_ASSET__mxwCDksf__"